import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppComponent } from '../app.component';
import { AppMainComponent } from './app.main.component';
import { AppState } from '../store/app.reducer';
import { Store } from '@ngrx/store';
//TODOINSERT import { selectUsername } from '../store/auth/auth.selector';
import { Observable, Subscription } from 'rxjs';
import * as AuthActions from 'src/app/store/auth/auth.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { selectStatusData } from '../store/task/task.selector';
import { StatusData } from '../model/api/data-rest';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
})
export class AppTopBarComponent implements OnInit, OnDestroy {
  // Observables and subscriptions
  usernameSel$: Observable<string | undefined>;
  usernameSub: Subscription | undefined;

  statusMaintanance$: Observable<StatusData | undefined>;
  statusMaintananceSub: Subscription | undefined;

  username = '';

  constructor(
    public appMain: AppMainComponent,
    public app: AppComponent,
    private store: Store<AppState>,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.statusMaintanance$ = this.store.select(selectStatusData);
  }

  ngOnInit(): void {
    this.usernameSub = this.usernameSel$?.subscribe(
      (username: string | undefined) => {
        if (username !== undefined) {
          this.username = username;
        }
      }
    );
    this.statusMaintananceSub = this.statusMaintanance$.subscribe(statusData => {
      if (statusData !== undefined && statusData !== null && statusData.Status !== undefined && statusData.Status > 0) {
        this.logout();
      }
    });
  }

  ngOnDestroy(): void {
    this.usernameSub?.unsubscribe();
    this.statusMaintananceSub?.unsubscribe();
  }


  userProfile(): void {
    this.router.navigate([`/${this.route.snapshot.routeConfig.path}`, 'profile']);
  }

  logout(): void {
    this.store.dispatch(AuthActions.authLogout());
  }
}
